// Regras PURAS do BID de Frete (épico PO1-2413): presets e etapas do processo,
// rótulos de situação/etapa/execução, validação do wizard (período com teto de
// 90 dias, pesos que somam 100), progresso das etapas assíncronas, economia e
// `precisaJustificar` para a adjudicação (H9). Sem React, sem rede: testável com
// Jest puro (Bids/__tests__/regras.test.js). A formatação reaproveita a dos
// Leilões (sem toLocaleString: o Node 12 do Jest/Amplify vem sem ICU).

import { ehCandidatoRede } from "../Leiloes/regras";

export { fmtBRL, fmtNumeroBR, fmtNumero, fmtPct, fmtData, fmtDataHora, hojeISO } from "../Leiloes/regras";

// ── Presets e etapas ─────────────────────────────────────────────────────────

export const PRESET_UI = {
  BENCHMARK: {
    label: "Benchmark",
    descricao: "Compara só as tabelas que você já tem: baseline, simulação e ranking.",
    etapas: ["ESCOPO", "BASELINE", "SIMULACAO", "RANKING"],
  },
  RFP_SIMPLES: {
    label: "RFP",
    descricao: "Convida transportadoras com um pacote anonimizado, recebe propostas na planilha modelo, escolhe as vencedoras por área e ativa as tabelas delas.",
    etapas: ["ESCOPO", "BASELINE", "PACOTE", "CONVITE", "PROPOSTAS", "SIMULACAO", "RANKING", "ADJUDICACAO", "INTEGRACAO"],
  },
};
export const PRESETS_ORDEM = ["BENCHMARK", "RFP_SIMPLES"];

// Tipo: tela | assincrona | prazo | automatica (seção "Etapas do processo").
export const ETAPA_UI = {
  ESCOPO: { label: "Escopo", tipo: "tela", descricao: "Filtros e prévia" },
  BASELINE: { label: "Baseline", tipo: "assincrona", descricao: "Congela as NFs e tira a foto do cobrado" },
  PACOTE: { label: "Pacote", tipo: "assincrona", descricao: "Planilha anonimizada e planilha modelo" },
  CONVITE: { label: "Convite", tipo: "tela", descricao: "Transportadoras e e-mail pelo MeuFrete" },
  PROPOSTAS: { label: "Propostas", tipo: "prazo", descricao: "Upload da planilha modelo até o prazo" },
  SIMULACAO: { label: "Simulação", tipo: "assincrona", descricao: "NFs congeladas × candidatas" },
  RANKING: { label: "Ranking", tipo: "tela", descricao: "Por nível e pesos" },
  ADJUDICACAO: { label: "Vencedoras", tipo: "tela", descricao: "Escolha das vencedoras por área" },
  INTEGRACAO: { label: "Integração", tipo: "automatica", descricao: "Cópia restrita da vencedora, ativa" },
};
export const ETAPAS_ORDEM = Object.keys(ETAPA_UI);

export const ETAPA_STATUS_UI = {
  PENDENTE: { label: "Pendente", tone: "neutral" },
  ATIVA: { label: "Em andamento", tone: "info" },
  CONCLUIDA: { label: "Concluída", tone: "success" },
  DESATUALIZADA: { label: "Desatualizada", tone: "warning" },
};

export const SITUACAO_UI = {
  RASCUNHO: { label: "Rascunho", tone: "neutral" },
  PUBLICADO: { label: "Publicado", tone: "info" },
  ENCERRADO: { label: "Encerrado", tone: "success" },
  CANCELADO: { label: "Cancelado", tone: "danger" },
};
export const SITUACOES_ORDEM = ["RASCUNHO", "PUBLICADO", "ENCERRADO", "CANCELADO"];

export const EXECUCAO_UI = {
  PENDENTE: { label: "Na fila", tone: "neutral", ativa: true },
  PUBLICANDO: { label: "Publicando lotes", tone: "info", ativa: true },
  EXECUTANDO: { label: "Executando", tone: "info", ativa: true },
  CONCLUIDO: { label: "Concluído", tone: "success", ativa: false },
  CONCLUIDO_PARCIAL: { label: "Concluído com erros", tone: "warning", ativa: false },
  FALHA: { label: "Falhou", tone: "danger", ativa: false },
};

export const NIVEL_UI = {
  BRASIL: { label: "Brasil" },
  REGIAO: { label: "Região" },
  UF: { label: "UF" },
  MODAL: { label: "Modal" },
};
export const NIVEIS_ORDEM = ["BRASIL", "REGIAO", "UF", "MODAL"];

export const FONTE_UI = {
  TABELA: { label: "Tabela", tone: "neutral" },
  CONECTOR: { label: "Conector", tone: "info" },
  PROPOSTA: { label: "Proposta", tone: "success" },
};

export const PARTICIPANTE_UI = {
  AGUARDANDO_CADASTRO: { label: "Aguardando cadastro", tone: "warning" },
  EM_CURADORIA: { label: "Em curadoria", tone: "warning" },
  CONVIDADO: { label: "Convidado", tone: "neutral" },
  VISUALIZOU: { label: "Abriu o BID", tone: "info" },
  ENVIOU: { label: "Enviou proposta", tone: "success" },
  RECUSOU: { label: "Recusou", tone: "danger" },
  EXPIRADO: { label: "Expirado", tone: "neutral" },
};

export const ORIGEM_PARTICIPANTE_UI = {
  CARTEIRA: { label: "Carteira" },
  SOURCING: { label: "Sourcing" },
  MANUAL: { label: "CNPJ manual" },
  // PO1-3648 (épico PO1-3359): candidato pela cobertura declarada da Rede.
  REDE: { label: "Rede Everlog" },
};

export const REGIOES = { N: "Norte", NE: "Nordeste", CO: "Centro-Oeste", SE: "Sudeste", S: "Sul" };
export const UFS_POR_REGIAO = {
  N: ["AC", "AM", "AP", "PA", "RO", "RR", "TO"],
  NE: ["AL", "BA", "CE", "MA", "PB", "PE", "PI", "RN", "SE"],
  CO: ["DF", "GO", "MS", "MT"],
  SE: ["ES", "MG", "RJ", "SP"],
  S: ["PR", "RS", "SC"],
};
// "Brasil" no seletor de regiões = as 5 regiões; só existe na tela (o backend
// recebe as regiões expandidas).
export const REGIAO_BRASIL = "BR";
export function expandirRegioes(regioes) {
  const l = (regioes || []).map((r) => String(r).toUpperCase());
  return l.indexOf(REGIAO_BRASIL) !== -1 ? Object.keys(REGIOES) : l;
}

export const PERIODO_MAX_DIAS = 90;
export const PESO_PADRAO = { custo: 70, prazo: 30 };
export const COBERTURA_MINIMA = 0.9;
export const PRAZO_PROPOSTAS_PADRAO_DIAS = 10;

export function etapasDoPreset(preset) {
  const p = PRESET_UI[preset] || PRESET_UI.BENCHMARK;
  return p.etapas.slice();
}

export function ehRfp(preset) {
  return preset === "RFP_SIMPLES";
}

// ── Período e escopo ─────────────────────────────────────────────────────────

function dataISO(v) {
  if (!v) return null;
  const d = new Date(`${String(v).slice(0, 10)}T00:00:00`);
  return Number.isFinite(d.getTime()) ? d : null;
}

// Dias corridos inclusivos entre duas datas 'YYYY-MM-DD' (01/01→01/01 = 1).
export function diasEntre(de, ate) {
  const a = dataISO(de);
  const b = dataISO(ate);
  if (!a || !b) return null;
  return Math.round((b.getTime() - a.getTime()) / 86400000) + 1;
}

// { ok, erro, dias }: obrigatório, de ≤ até, teto de 90 dias.
export function periodoValido(de, ate) {
  if (!de || !ate) return { ok: false, erro: "Informe o período de emissão.", dias: null };
  const dias = diasEntre(de, ate);
  if (dias === null) return { ok: false, erro: "Data inválida.", dias: null };
  if (dias < 1) return { ok: false, erro: "A data final precisa ser igual ou depois da inicial.", dias };
  if (dias > PERIODO_MAX_DIAS) return { ok: false, erro: `O período não pode passar de ${PERIODO_MAX_DIAS} dias (${dias} informados).`, dias };
  return { ok: true, erro: null, dias };
}

// UFs efetivas do escopo: as marcadas + as das regiões marcadas (sem repetir).
export function ufsDoEscopo(ufs, regioes) {
  const set = {};
  (ufs || []).forEach((u) => {
    if (u) set[String(u).toUpperCase()] = true;
  });
  expandirRegioes(regioes).forEach((r) => {
    (UFS_POR_REGIAO[r] || []).forEach((u) => {
      set[u] = true;
    });
  });
  return Object.keys(set).sort();
}

function valores(lista) {
  return (lista || []).map((o) => (o && typeof o === "object" ? o.value : o)).filter((v) => v !== null && v !== undefined && v !== "");
}

export function validarIdentificacao(form) {
  const erros = {};
  if (!form || !String(form.nome || "").trim()) erros.nome = "Dê um nome ao BID.";
  else if (String(form.nome).trim().length > 100) erros.nome = "O nome tem no máximo 100 caracteres.";
  if (!form || !PRESET_UI[form.preset]) erros.preset = "Escolha o modelo.";
  return erros;
}

export function validarEscopo(form) {
  const erros = {};
  const p = periodoValido(form && form.dataEmissaoDe, form && form.dataEmissaoAte);
  if (!p.ok) erros.periodo = p.erro;
  if (!ufsDoEscopo(valores(form && form.ufs), valores(form && form.regioes)).length) erros.destino = "Escolha ao menos uma UF ou região de destino.";
  return erros;
}

export function pesosValidos(custo, prazo) {
  const c = Number(custo);
  const p = Number(prazo);
  if (!Number.isInteger(c) || !Number.isInteger(p)) return false;
  if (c < 0 || p < 0 || c > 100 || p > 100) return false;
  return c + p === 100;
}

// Digitou o custo → o prazo acompanha (sempre somam 100).
export function complementoPeso(valor) {
  const n = Math.round(Number(valor));
  if (!Number.isFinite(n)) return PESO_PADRAO.prazo;
  return Math.min(100, Math.max(0, 100 - n));
}

export function validarCriterios(form) {
  const erros = {};
  if (!pesosValidos(form && form.pesoCusto, form && form.pesoPrazo)) erros.pesos = "Os pesos de custo e prazo precisam ser inteiros de 0 a 100 e somar 100.";
  if (!NIVEL_UI[form && form.nivelInicial]) erros.nivelInicial = "Escolha o nível inicial do ranking.";
  return erros;
}

// Só no RFP: cabeçalho da planilha modelo (Tpl*) e prazo das propostas.
export function validarProposta(form, hoje) {
  const erros = {};
  if (!form) return { tplIdModal: "Obrigatório." };
  if (!form.tplIdModal) erros.tplIdModal = "Escolha o modal da proposta.";
  if (!form.tplIdFreteUnidade) erros.tplIdFreteUnidade = "Escolha a unidade de frete.";
  if (!form.prazoPropostas) erros.prazoPropostas = "Informe o prazo para as propostas.";
  else {
    const base = hoje ? dataISO(hoje) : dataISO(new Date().toISOString());
    const d = dataISO(form.prazoPropostas);
    if (!d) erros.prazoPropostas = "Data inválida.";
    else if (base && d.getTime() <= base.getTime()) erros.prazoPropostas = "O prazo precisa ser depois de hoje.";
  }
  return erros;
}

// Payload de POST /gobid/bids a partir do estado do wizard (listas como arrays
// de ids/siglas; o backend grava com `;`).
export function montarPayload(form) {
  const f = form || {};
  const base = {
    nome: String(f.nome || "").trim(),
    preset: f.preset,
    dataEmissaoDe: f.dataEmissaoDe,
    dataEmissaoAte: f.dataEmissaoAte,
    ufs: valores(f.ufs),
    regioes: expandirRegioes(valores(f.regioes)),
    idsTransportadoraAtual: valores(f.transportadorasAtuais),
    idsNegocio: valores(f.negocios),
    idsTipoServico: valores(f.servicos),
    idsModal: valores(f.modais),
    nivelInicial: f.nivelInicial,
    pesoCusto: Number(f.pesoCusto),
    pesoPrazo: Number(f.pesoPrazo),
  };
  if (ehRfp(f.preset)) {
    base.tplIdCidadeOrigem = f.tplIdCidadeOrigem || null;
    base.tplIdModal = f.tplIdModal || null;
    base.tplIdNegocio = f.tplIdNegocio || null;
    base.tplServico = f.tplServico || null;
    base.tplIdTipoServico = f.tplIdTipoServico || null;
    base.tplIdFreteUnidade = f.tplIdFreteUnidade || null;
    base.prazoPropostas = f.prazoPropostas || null;
    // TODO H7: convidados iniciais (`participantes`) entram aqui quando o
    // seletor do passo 4 existir; até lá o convite é feito na aba Convites.
    base.participantes = Array.isArray(f.participantes) ? f.participantes : [];
  }
  return base;
}

// Só o escopo, para POST /previa (sem nome/preset).
export function montarEscopoPrevia(form) {
  const p = montarPayload({ ...form, preset: "BENCHMARK" });
  return {
    dataEmissaoDe: p.dataEmissaoDe,
    dataEmissaoAte: p.dataEmissaoAte,
    ufs: p.ufs,
    regioes: p.regioes,
    idsTransportadoraAtual: p.idsTransportadoraAtual,
    idsNegocio: p.idsNegocio,
    idsTipoServico: p.idsTipoServico,
    idsModal: p.idsModal,
  };
}

// ── Etapas, dependências e ações ─────────────────────────────────────────────

function statusDe(bid, etapa) {
  const e = ((bid && bid.etapas) || []).find((x) => x && x.etapa === etapa);
  return e ? e.status : null;
}

// Etapa atual = a primeira ATIVA; senão a primeira que não está CONCLUIDA.
export function etapaAtual(bid) {
  const lista = ((bid && bid.etapas) || []).slice().sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  if (!lista.length) return null;
  const ativa = lista.find((e) => e.status === "ATIVA");
  if (ativa) return ativa.etapa;
  const aberta = lista.find((e) => e.status !== "CONCLUIDA");
  return aberta ? aberta.etapa : lista[lista.length - 1].etapa;
}

export function execucaoMaisRecente(execucoes, etapa) {
  const lista = (execucoes || []).filter((e) => e && e.etapa === etapa);
  if (!lista.length) return null;
  return lista.slice().sort((a, b) => new Date(b.inicio || 0).getTime() - new Date(a.inicio || 0).getTime())[0];
}

export function execucaoAtiva(exec) {
  return Boolean(exec && EXECUCAO_UI[exec.situacao] && EXECUCAO_UI[exec.situacao].ativa);
}

// 0..1 pelos itens (ou lotes) feitos; concluída = 1; sem execução = 0.
export function progressoExecucao(exec) {
  if (!exec) return 0;
  if (exec.situacao === "CONCLUIDO") return 1;
  const it = Number(exec.itensTotal);
  const if_ = Number(exec.itensFeitos);
  if (it > 0 && Number.isFinite(if_)) return Math.min(1, Math.max(0, if_ / it));
  const lt = Number(exec.lotesTotal);
  const lf = Number(exec.lotesFeitos);
  if (lt > 0 && Number.isFinite(lf)) return Math.min(1, Math.max(0, lf / lt));
  return 0;
}

// Alguma etapa assíncrona rodando → o detalhe faz polling de 5 s.
export function temExecucaoAtiva(execucoes) {
  return (execucoes || []).some(execucaoAtiva);
}

// Ações do trilho conforme a etapa e as dependências da spec:
// - BASELINE: escopo salvo; recriar exige confirmação (marca PACOTE e SIMULACAO
//   como desatualizados); travada depois do CONVITE concluído.
// - PACOTE (só RFP) e SIMULACAO exigem BASELINE concluída e não desatualizada.
// - SIMULACAO no RFP pode rodar antes das propostas (só tabelas vigentes) e de novo depois.
// Devolve { baseline, pacote, executar } com { habilitado, motivo, recriar }.
export function acoesDisponiveis(bid, execucoes) {
  const vazio = { habilitado: false, motivo: null, recriar: false, rodando: false };
  if (!bid) return { baseline: vazio, pacote: vazio, executar: vazio };
  const cancelado = bid.situacao === "CANCELADO" || bid.situacao === "ENCERRADO";
  const rfp = ehRfp(bid.preset);
  const baselineStatus = statusDe(bid, "BASELINE");
  const conviteFeito = statusDe(bid, "CONVITE") === "CONCLUIDA";
  const rodandoBaseline = execucaoAtiva(execucaoMaisRecente(execucoes, "BASELINE"));
  const rodandoPacote = execucaoAtiva(execucaoMaisRecente(execucoes, "PACOTE"));
  const rodandoSimulacao = execucaoAtiva(execucaoMaisRecente(execucoes, "SIMULACAO"));
  const algoRodando = rodandoBaseline || rodandoPacote || rodandoSimulacao;

  const baseline = { ...vazio, rodando: rodandoBaseline, recriar: baselineStatus === "CONCLUIDA" || baselineStatus === "DESATUALIZADA" };
  if (cancelado) baseline.motivo = "BID encerrado ou cancelado.";
  else if (conviteFeito) baseline.motivo = "Depois do convite, o escopo e a baseline ficam travados.";
  else if (algoRodando) baseline.motivo = "Aguarde a etapa em execução.";
  else baseline.habilitado = true;

  const pacote = { ...vazio, rodando: rodandoPacote, recriar: statusDe(bid, "PACOTE") === "CONCLUIDA" };
  if (!rfp) pacote.motivo = "Só no RFP.";
  else if (cancelado) pacote.motivo = "BID encerrado ou cancelado.";
  else if (baselineStatus !== "CONCLUIDA") pacote.motivo = baselineStatus === "DESATUALIZADA" ? "Recrie a baseline antes." : "Crie a baseline antes.";
  else if (conviteFeito) pacote.motivo = "O pacote já foi enviado às convidadas.";
  else if (algoRodando) pacote.motivo = "Aguarde a etapa em execução.";
  else pacote.habilitado = true;

  const executar = { ...vazio, rodando: rodandoSimulacao, recriar: statusDe(bid, "SIMULACAO") === "CONCLUIDA" || statusDe(bid, "SIMULACAO") === "DESATUALIZADA" };
  if (cancelado) executar.motivo = "BID encerrado ou cancelado.";
  else if (baselineStatus !== "CONCLUIDA") executar.motivo = baselineStatus === "DESATUALIZADA" ? "Recrie a baseline antes." : "Crie a baseline antes.";
  else if (algoRodando) executar.motivo = "Aguarde a etapa em execução.";
  else executar.habilitado = true;

  return { baseline, pacote, executar };
}

// ── Ranking, economia e adjudicação ──────────────────────────────────────────

export function economia(vrBaseline, vrFrete) {
  const b = Number(vrBaseline);
  const f = Number(vrFrete);
  if (!Number.isFinite(b) || !Number.isFinite(f)) return null;
  return b - f;
}

// (baseline − frete) / baseline; positivo = economia. null sem baseline.
export function economiaPct(vrBaseline, vrFrete) {
  const b = Number(vrBaseline);
  const f = Number(vrFrete);
  if (!(b > 0) || !Number.isFinite(f)) return null;
  return (b - f) / b;
}

export function coberturaParcial(cobertura) {
  const c = Number(cobertura);
  return Number.isFinite(c) && c < COBERTURA_MINIMA;
}

// Ordena como o backend: parciais no fim; depois posição; empate pela
// incumbente e pelo menor frete (defensivo para resposta sem `posicao`).
export function ordenarRanking(candidatas) {
  return (candidatas || [])
    .slice()
    .sort((a, b) => {
      const pa = coberturaParcial(a.cobertura) ? 1 : 0;
      const pb = coberturaParcial(b.cobertura) ? 1 : 0;
      if (pa !== pb) return pa - pb;
      const posA = a.posicao != null ? Number(a.posicao) : Infinity;
      const posB = b.posicao != null ? Number(b.posicao) : Infinity;
      if (posA !== posB) return posA - posB;
      const sa = Number(a.score) || 0;
      const sb = Number(b.score) || 0;
      if (sa !== sb) return sb - sa;
      if (Boolean(a.ehIncumbente) !== Boolean(b.ehIncumbente)) return a.ehIncumbente ? -1 : 1;
      return (Number(a.vrFrete) || 0) - (Number(b.vrFrete) || 0);
    });
}

// H9: a justificativa é obrigatória quando a transportadora não é a primeira
// do ranking do nível e da área escolhidos.
export function precisaJustificar(ranking, idTransportadora) {
  const lista = ordenarRanking((ranking && ranking.candidatas) || ranking);
  if (!lista.length || idTransportadora === null || idTransportadora === undefined) return false;
  return String(lista[0].idTransportadora) !== String(idTransportadora);
}

// "Brasil" | "Sudeste" | "MG" | nome do modal (por `rotulo` da API ou pelos mapas locais).
export function rotuloArea(nivel, area, areas) {
  const achada = (areas || []).find((a) => a && a.nivel === nivel && String(a.area) === String(area));
  if (achada && achada.rotulo) return achada.rotulo;
  if (nivel === "BRASIL") return "Brasil";
  if (nivel === "REGIAO") return REGIOES[area] || area;
  return area === null || area === undefined ? "—" : String(area);
}

// ── Listagem ─────────────────────────────────────────────────────────────────

export function matchesSearch(item, termo) {
  if (!termo) return true;
  const alvo = String(termo).toLowerCase();
  const campos = [item.id != null ? `#${item.id}` : null, item.id != null ? String(item.id) : null, item.nome, item.ufs, PRESET_UI[item.preset] && PRESET_UI[item.preset].label];
  return campos.some((c) => c && String(c).toLowerCase().indexOf(alvo) !== -1);
}

// 'YYYY-MM-DD' (ou ISO com hora) → "DD/MM/YYYY" sem passar por Date (sem
// deslocar o dia por fuso; ver reference_frontend_hub_data_sql_utc_helper_dateonly).
export function fmtDataISO(v) {
  if (!v) return "—";
  const s = String(v).slice(0, 10).split("-");
  return s.length === 3 && s[0].length === 4 ? `${s[2]}/${s[1]}/${s[0]}` : String(v);
}

// "01/09/2026 a 30/09/2026 (30 dias)"
export function fmtPeriodo(de, ate) {
  if (!de || !ate) return "—";
  const d = diasEntre(de, ate);
  return `${fmtDataISO(de)} a ${fmtDataISO(ate)}${d ? ` (${d} dia${d > 1 ? "s" : ""})` : ""}`;
}

// Prévia (POST /gobid/bids/previa, contrato do backend_hub): `candidatas.tabela`,
// `.conector` e `.proposta` são ARRAYS e `candidatas.total` é número; vêm
// também `estimativaChamadasConector`, `ufs` e `dias`.
function qtd(v) {
  if (Array.isArray(v)) return v.length;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function resumoPrevia(previa) {
  if (!previa) return null;
  const cand = previa.candidatas || {};
  const tabela = qtd(cand.tabela);
  const conector = qtd(cand.conector);
  const proposta = qtd(cand.proposta);
  const total = cand.total != null && Number.isFinite(Number(cand.total)) ? Number(cand.total) : tabela + conector + proposta;
  return {
    qtdNf: Number(previa.qtdNf) || 0,
    qtdComCte: Number(previa.qtdComCte) || 0,
    qtdRomaneiosLotacao: Number(previa.qtdRomaneiosLotacao) || 0,
    candidatasTabela: tabela,
    candidatasConector: conector,
    candidatasProposta: proposta,
    candidatasTotal: total,
    estimativaCalculos: Number(previa.estimativaCalculos) || 0,
    estimativaChamadasConector: Number(previa.estimativaChamadasConector) || 0,
    estimativaMinutos: previa.estimativaMinutos != null ? Number(previa.estimativaMinutos) : null,
    ufs: Array.isArray(previa.ufs) ? previa.ufs : String(previa.ufs || "").split(";").filter(Boolean),
    dias: previa.dias != null ? Number(previa.dias) : null,
    coberturaCte: Number(previa.qtdNf) > 0 ? Number(previa.qtdComCte) / Number(previa.qtdNf) : null,
  };
}

// ── Erros da API: { error, code, ...details } ────────────────────────────────

export function erroDaApi(err, fallback) {
  const resp = err && err.response;
  const data = (resp && resp.data) || {};
  const errors = data.errors && typeof data.errors === "object" ? data.errors : null;
  let mensagem = typeof data.error === "string" ? data.error : null;
  if (!mensagem && data.error && typeof data.error === "object") mensagem = Object.values(data.error).join("; ");
  return {
    status: resp ? resp.status : null,
    code: data.code || null,
    mensagem: mensagem || fallback || "Erro inesperado.",
    errors,
    precisaConfirmar: Boolean(data.precisaConfirmar) || data.code === "baseline_existente",
    data,
  };
}

// "SP;MG" ou ["SP","MG"] → ["SP","MG"]
export function listaSiglas(v) {
  if (Array.isArray(v)) return v.map(String).filter(Boolean);
  return String(v || "")
    .split(/[;,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function fmtSiglas(v) {
  const l = listaSiglas(v);
  return l.length ? l.join(", ") : "—";
}

// UFs do escopo do BID salvo (Ufs + Regioes expandidas).
export function ufsDoBid(bid) {
  if (!bid) return [];
  return ufsDoEscopo(listaSiglas(bid.ufs), listaSiglas(bid.regioes));
}

// Nome da candidata no ranking: `nome`, senão `transportadora`; com a tabela.
export function nomeCandidata(c) {
  if (!c) return "—";
  return c.nome || c.transportadora || (c.idTransportadora != null ? `Transportadora ${c.idTransportadora}` : "—");
}

// Etapa atual da lista/detalhe: string (backend) ou { etapa } ou derivada das etapas.
export function etapaAtualDe(item) {
  if (!item) return null;
  if (typeof item.etapaAtual === "string") return item.etapaAtual;
  if (item.etapaAtual && item.etapaAtual.etapa) return item.etapaAtual.etapa;
  return etapaAtual(item);
}

export function statusDaEtapa(bid, etapa) {
  return statusDe(bid, etapa);
}

// ── Convite e propostas (H7) ─────────────────────────────────────────────────

export const JUSTIFICATIVA_MIN = 10;
const CNPJ_RE = /^\d{14}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function soDigitos(v) {
  return String(v || "").replace(/\D/g, "");
}

// CNPJ com dígitos verificadores válidos (módulo 11).
export function cnpjValido(v) {
  const c = soDigitos(v);
  if (!CNPJ_RE.test(c) || /^(\d)\1+$/.test(c)) return false;
  const calc = (base) => {
    const pesos = base.length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const soma = base.split("").reduce((acc, d, i) => acc + Number(d) * pesos[i], 0);
    const r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const d1 = calc(c.slice(0, 12));
  const d2 = calc(c.slice(0, 12) + d1);
  return c.slice(12) === `${d1}${d2}`;
}

export function emailOk(v) {
  return EMAIL_RE.test(String(v || "").trim());
}

export function fmtCnpj(v) {
  const c = soDigitos(v);
  if (c.length !== 14) return v || "—";
  return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12)}`;
}

// Monta o corpo de POST /participantes a partir da seleção do seletor:
// candidatas marcadas (carteira/Sourcing, com e-mail digitado quando não tinham)
// + CNPJs manuais.
export function montarParticipantes(candidatos, selecionados, emailsDigitados, manuais) {
  const lista = [];
  (candidatos || []).forEach((c) => {
    if (!selecionados || !selecionados[c.idTransportadora]) return;
    // PO1-3648: candidato da Rede Everlog vai com origem REDE (cabe em NVARCHAR(10)).
    const p = { idTransportadora: c.idTransportadora, origem: c.naCarteira ? "CARTEIRA" : ehCandidatoRede(c) ? "REDE" : "SOURCING" };
    const dig = String((emailsDigitados && emailsDigitados[c.idTransportadora]) || "").trim();
    if (dig) p.email = dig;
    lista.push(p);
  });
  (manuais || []).forEach((m) => {
    const p = { cnpj: soDigitos(m.cnpj), origem: "MANUAL" };
    if (m.email) p.email = String(m.email).trim();
    if (m.nome) p.razaoSocial = String(m.nome).trim();
    lista.push(p);
  });
  return lista;
}

export function validarManual(m, existentes) {
  const erros = {};
  if (!cnpjValido(m && m.cnpj)) erros.cnpj = "CNPJ inválido.";
  else if ((existentes || []).some((x) => soDigitos(x.cnpj) === soDigitos(m.cnpj))) erros.cnpj = "CNPJ já incluído.";
  if (!emailOk(m && m.email)) erros.email = "Informe um e-mail válido.";
  return erros;
}

export function resumoParticipantes(participantes) {
  const r = { total: 0 };
  Object.keys(PARTICIPANTE_UI).forEach((k) => {
    r[k] = 0;
  });
  (participantes || []).forEach((p) => {
    r.total += 1;
    if (r[p.estado] !== undefined) r[p.estado] += 1;
  });
  return r;
}

// Publicar exige o PACOTE concluído, ao menos 1 participante e o BID ainda não publicado.
export function podePublicar(bid, participantes) {
  if (!bid || !ehRfp(bid.preset)) return { ok: false, motivo: "Só no RFP." };
  if (bid.situacao !== "RASCUNHO" || statusDe(bid, "CONVITE") === "CONCLUIDA") return { ok: false, motivo: "O BID já foi publicado." };
  if (statusDe(bid, "PACOTE") !== "CONCLUIDA") return { ok: false, motivo: "Gere o pacote antes de publicar." };
  if (!(participantes || []).length) return { ok: false, motivo: "Inclua ao menos uma transportadora." };
  if (!bid.prazoPropostas) return { ok: false, motivo: "Defina o prazo das propostas." };
  return { ok: true, motivo: null };
}

export function podeEncerrarPropostas(bid) {
  if (!bid || !ehRfp(bid.preset)) return false;
  return statusDe(bid, "CONVITE") === "CONCLUIDA" && statusDe(bid, "PROPOSTAS") !== "CONCLUIDA";
}

// Reenvio só para quem ainda não respondeu.
export function podeReenviar(p) {
  return Boolean(p) && ["AGUARDANDO_CADASTRO", "CONVIDADO", "VISUALIZOU", "EXPIRADO"].indexOf(p.estado) !== -1;
}

// ── Adjudicação (H9) ─────────────────────────────────────────────────────────

export const PAPEL_UI = {
  PRINCIPAL: { label: "Principal", tone: "success" },
  SECUNDARIA: { label: "Secundária", tone: "info" },
};

// Área da adjudicação → UFs (Brasil = todas do escopo; região = as da região
// dentro do escopo; lista = as escolhidas).
export function ufsDaArea(nivel, area, ufs, ufsEscopo) {
  const escopo = ufsEscopo || [];
  if (nivel === "BRASIL") return escopo.slice();
  if (nivel === "REGIAO") return (UFS_POR_REGIAO[area] || []).filter((u) => !escopo.length || escopo.indexOf(u) !== -1);
  return listaSiglas(ufs).filter((u) => !escopo.length || escopo.indexOf(u) !== -1);
}

// Justificativa obrigatória se a escolhida não é a 1ª em ALGUMA das áreas
// consultadas (lista de UFs = um ranking por UF).
export function precisaJustificarEmAreas(rankings, idTransportadora) {
  return (rankings || []).some((r) => {
    const lista = (r && r.candidatas) || [];
    return lista.length > 0 && precisaJustificar(lista, idTransportadora);
  });
}

// Candidatas de vários rankings sem repetir (transportadora + tabela + fonte).
export function unirCandidatas(rankings) {
  const vistos = {};
  const out = [];
  (rankings || []).forEach((r) => {
    ordenarRanking((r && r.candidatas) || []).forEach((c) => {
      const k = `${c.idTransportadora}|${c.idFreteTabela || ""}|${c.fonte || ""}`;
      if (vistos[k]) return;
      vistos[k] = true;
      out.push(c);
    });
  });
  return out;
}

export function chaveCandidata(c) {
  return c ? `${c.idTransportadora}|${c.idFreteTabela || ""}|${c.fonte || ""}` : "";
}

export function validarAdjudicacao(form, { precisa, ufs } = {}) {
  const e = {};
  const f = form || {};
  if (!(ufs || []).length) e.area = "A área escolhida não tem UF do escopo.";
  if (!f.candidata) e.candidata = "Escolha a transportadora vencedora.";
  if (!PAPEL_UI[f.papel]) e.papel = "Escolha o papel.";
  if (f.percentual !== "" && f.percentual !== null && f.percentual !== undefined) {
    const p = Number(String(f.percentual).replace(",", "."));
    if (!Number.isFinite(p) || p <= 0 || p > 100) e.percentual = "O percentual vai de 0,01 a 100.";
  }
  if (!f.vigenciaIni || !f.vigenciaFim) e.vigencia = "Informe a vigência.";
  else if (diasEntre(f.vigenciaIni, f.vigenciaFim) < 1) e.vigencia = "O fim da vigência precisa ser igual ou depois do início.";
  if (precisa && String(f.justificativa || "").trim().length < JUSTIFICATIVA_MIN) e.justificativa = `Fora do 1º lugar do ranking: justifique com ${JUSTIFICATIVA_MIN} caracteres ou mais.`;
  return e;
}

export function montarAdjudicacao(form, { ufs, precisa } = {}) {
  const f = form || {};
  const c = f.candidata || {};
  const corpo = {
    nivel: f.nivel,
    idTransportadora: c.idTransportadora,
    idFreteTabela: c.idFreteTabela || null,
    fonte: c.fonte || null,
    papel: f.papel,
    vigenciaIni: f.vigenciaIni,
    vigenciaFim: f.vigenciaFim,
  };
  if (f.nivel === "UF") corpo.ufs = ufs || [];
  else corpo.area = f.nivel === "BRASIL" ? "BR" : f.area;
  if (f.percentual !== "" && f.percentual !== null && f.percentual !== undefined) corpo.percentual = Number(String(f.percentual).replace(",", "."));
  if (precisa || String(f.justificativa || "").trim()) corpo.justificativa = String(f.justificativa || "").trim();
  return corpo;
}

// Cobertura: { ufsSemVencedora, ufsSemPrincipal, somaPercentuais } do backend,
// ou derivada das adjudicações quando a resposta não trouxer.
export function situacaoCobertura(ufsEscopo, cobertura, adjudicacoes) {
  const porUf = {};
  (ufsEscopo || []).forEach((u) => {
    porUf[u] = { uf: u, vencedoras: 0, principal: false, soma: 0, temPercentual: false, todasComPercentual: true };
  });
  (adjudicacoes || []).forEach((a) => {
    listaSiglas(a.ufs).forEach((u) => {
      if (!porUf[u]) porUf[u] = { uf: u, vencedoras: 0, principal: false, soma: 0, temPercentual: false, todasComPercentual: true };
      const x = porUf[u];
      x.vencedoras += 1;
      if (a.papel === "PRINCIPAL") x.principal = true;
      if (a.percentual != null && a.percentual !== "") {
        x.soma += Number(a.percentual) || 0;
        x.temPercentual = true;
      } else x.todasComPercentual = false;
    });
  });
  const cob = cobertura || {};
  const semVencedora = Array.isArray(cob.ufsSemVencedora) ? cob.ufsSemVencedora : Object.keys(porUf).filter((u) => porUf[u].vencedoras === 0);
  const semPrincipal = Array.isArray(cob.ufsSemPrincipal) ? cob.ufsSemPrincipal : Object.keys(porUf).filter((u) => porUf[u].vencedoras > 0 && !porUf[u].principal);
  const soma = cob.somaPercentuais && typeof cob.somaPercentuais === "object" ? cob.somaPercentuais : null;
  const acimaDe100 = Object.keys(porUf).filter((u) => (soma && soma[u] != null ? Number(soma[u]) : porUf[u].soma) > 100);
  const abaixoDe100 = Object.keys(porUf).filter((u) => {
    const x = porUf[u];
    const v = soma && soma[u] != null ? Number(soma[u]) : x.soma;
    return x.vencedoras > 0 && x.temPercentual && x.todasComPercentual && v < 100;
  });
  const ufs = Object.keys(porUf)
    .sort()
    .map((u) => {
      const x = porUf[u];
      let estado = "ok";
      if (semVencedora.indexOf(u) !== -1) estado = "sem_vencedora";
      else if (semPrincipal.indexOf(u) !== -1) estado = "sem_principal";
      else if (acimaDe100.indexOf(u) !== -1) estado = "acima_100";
      return { ...x, soma: soma && soma[u] != null ? Number(soma[u]) : x.soma, estado };
    });
  const completa = cob.completa != null ? Boolean(cob.completa) : semVencedora.length === 0 && semPrincipal.length === 0 && acimaDe100.length === 0;
  return { ufs, semVencedora, semPrincipal, acimaDe100, abaixoDe100, completa };
}
